<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col>
        <relatorio-cotas-unidade-list-filtro @search="handleGetProgramacoes" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <cotas-programacao-unidade ref="cotas" v-bind:params="params" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import RelatorioCotasUnidadeListFiltro from '@/components/patio/relatorioCotasUnidade/RelatorioCotasUnidadeListFiltro.vue'
import CotasProgramacaoUnidade from '@/components/patio/relatorioCotasUnidade/Cotas.vue'

import { data } from './_data'

export default {
  name: 'RelatorioCotasUnidade',

  components: {
    RelatorioCotasUnidadeListFiltro,
    CotasProgramacaoUnidade,
  },
  data,
  computed: {
    ...mapState('auth', ['empresaAtual']),
    ...mapState('relatorioCotasUnidade', ['params']),
  },
  methods: {
    async handleGetProgramacoes() {
      await this.$refs.cotas.atualizarEstrutura(this.params)
    },
  },
}
</script>
